import { giftingAsset, giftingAssetUrl } from 'components/gifting/assets';

// Ring voucher imagery on S3 under web_v2/gifting/voucher/.

/** `src` for CustomImage / GiftingImage. */
export const voucherAsset = (file: string): string =>
  giftingAsset(`voucher/${file}`);

/** Absolute URL for CSS `url()` / masks. */
export const voucherAssetUrl = (file: string): string =>
  giftingAssetUrl(`voucher/${file}`);
